import React from "react";
import { Trans } from "react-i18next";

interface ThresholdExplainProps {
  delay_threshold: string;
  i18nKey: string;
}

export default class ThresholdExplaination extends React.PureComponent<ThresholdExplainProps> {
  render() {
    return (
      <div className="threshold_explanation">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            textAlign: "center",
            borderStyle: "solid",
            borderWidth: "0.2rem",
            width: "3rem",
            height: "3rem",
            paddingTop: "0.7rem",
            paddingBottom: "1rem",
            borderRadius: "1rem",
            alignSelf: "center"
            }}>
            <div style={{fontSize: "12px"}}>
              {"XX%"}
            </div>
          </div>
        <Trans
          i18nKey={this.props.i18nKey}
          values={{
            delay_threshold: this.props.delay_threshold === '5min' ? '5' : '15'
          }}
          components={{ 
            color: <span style={{ color: '#0000AA' }} />,
            italic: <i />
          }}
        />
        </div>
      </div>
    );
  }
}
